import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallToActionSection() {
  return <section id="call-to-action-section" className="bg-background py-32 md:py-48 flex items-center justify-center">
      <div className="container mx-auto px-4 text-center max-w-3xl">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 tracking-tight">
          Want a personalized protocol?
        </h2>
        
        <p className="text-xl md:text-2xl text-muted-foreground mb-12 font-default">
          Message us to get started.
        </p>
        
        <Button asChild size="lg" className="bg-[var(--color-green-accent)] hover:bg-[var(--color-green-accent)]/90 text-white rounded-full px-10 py-7 text-lg font-default transition-all duration-300 shadow-md hover:shadow-lg">
          <Link to="/ContactPage">
            Contact Us
          </Link>
        </Button>
      </div>
    </section>;
}